
import { Component, Prop, Vue } from 'vue-property-decorator'
import Bus from '@/utils/bus'

@Component
export default class AdPanel extends Vue {
  @Prop()
  botInfo!: any

  sendQuestion(question: string) {
    Bus.$emit('requestAnswer', question)
  }
}
